import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_UNIT = "identity-service/identity/units";

const RESOURCES = {
	LIST_UNITS: (id) => `${BASE_UNIT}/condominiums/${id}`,

	LIST_UNITS_PAGINATED: (
		page,
		search,
		organizationId,
		condominiumID,
		orderBy,
		deviceData,
		tagExternalId,
		linkableToUser,
		scopeTags,
	) => {
		const params = new URLSearchParams({
			searchBy: search,
			parentUnitId: condominiumID,
			page,
			limit: 8,
			orderBy: orderBy.collumnTitle,
			orderDirection: orderBy.orderDirection,
		});
		if (deviceData != null) params.append('deviceData', deviceData);
		if (tagExternalId) params.append('tagExternalId', tagExternalId);
		if (linkableToUser !== null) params.append('linkableToUser', linkableToUser);
		if (scopeTags !== null) params.append('scopeTags', scopeTags.join(','));
		return `${BASE_UNIT}/organizations/${organizationId}/paginated?${params.toString()}`;
	},

	GET_UNIT_BY_ID: (id) => `${BASE_UNIT}/${id}`,
	BATCH_UNIT: () => `${BASE_UNIT}/batch`,
	DELETE_UNIT: (id) => `${BASE_UNIT}/${id}`,
	UPDATE_UNIT: (id) => `${BASE_UNIT}/${id}`,
};

class UnitService {
	static async listUnitsPaginated(
		page,
		customInput1,
		organizationId,
		condominiumId,
		orderBy,
		deviceData,
		tagExternalId,
		linkableToUser = null,
		scopeTags = [],
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_UNITS_PAGINATED(
					page,
					customInput1,
					organizationId,
					condominiumId,
					orderBy,
					deviceData,
					tagExternalId,
					linkableToUser,
					scopeTags,
				),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar unidades",
			});
			return error.response;
		}
	}

	static async getUnitById(id) {
		try {
			return await axios.get(RESOURCES.GET_UNIT_BY_ID(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar unidade do usuario",
			});
			return error.response;
		}
	}

	static async createUnit(payload) {
		try {
			const response = await axios.post(BASE_UNIT, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Unidade criada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao criar unidade",
			});
			return error.response;
		}
	}

	static async createBatchUnit(payload) {
		try {
			const response = await axios.post(RESOURCES.BATCH_UNIT(), payload);
			ResponseAlerts({
				response: response,
				successMessage: "Unidades em lote criadas com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao criar unidades em lote",
			});
			return error.response;
		}
	}

	static async deleteUnit(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_UNIT(id));
			ResponseAlerts({
				response: response,
				successMessage: "Unidade excluída com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao excluir unidade",
			});
			return error.response;
		}
	}

	static async updateUnit(id, payload) {
		return await axios
			.put(BASE_UNIT + "/" + id, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Unidade atualizada com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar unidade",
				});
				return error.response;
			});
	}
}

export default UnitService;
